import React from 'react';
import { Form, Tooltip } from 'antd';
import { CrownIcon } from '../core/icons'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
};

// ant wrapped redux form examples: https://codesandbox.io/s/JZYL70WpK
const makeField = Component => ({ layout=formItemLayout, input, meta, children, hasFeedback, label, premiumOnly, ...rest }) => {
  const hasError = meta.touched && meta.invalid;

  const {value, ...newInput} = input
  // if (value!="") newInput.value = value
  if (value!="" || !rest.placeholder) newInput.value = value

  return (
    <Form.Item
      {...layout}
      colon={!premiumOnly}
      label={premiumOnly ? (
            <span>
              {label}&nbsp;
              <Tooltip title="This is a Premium feature">
                <CrownIcon height="17"/>
              </Tooltip>
            </span>
          )
          : label
        }
      validateStatus={hasError ? 'error' : 'success'}
      hasFeedback={hasFeedback}
      help={hasError && meta.error}
      >
        <Component {...rest} {...newInput} children={children} />
      </Form.Item>
    );
  };

export default makeField


//
// // ant wrapped redux form examples: https://codesandbox.io/s/JZYL70WpK
// const makeField = Component => ({ formLayout, input, meta, children, hasFeedback, label, ...rest }) => {
//   const hasError = meta.touched && meta.invalid;
//   const formItemLayout = formLayout === 'horizontal' ? {
//       labelCol: {
//         xs: { span: 24 },
//         sm: { span: 8 },
//       },
//       wrapperCol: {
//         xs: { span: 24 },
//         sm: { span: 14 },
//       },
//     } : null;
//
//   return (
//     <FormItem
//       label={label}
//       validateStatus={hasError ? 'error' : 'success'}
//       hasFeedback={hasFeedback && hasError}
//       help={hasError && meta.error}
//       {...formItemLayout}
//     >
//       <Component {...input} {...rest} children={children} />
//     </FormItem>
//   );
// };



// WEBPACK FOOTER //
// ./src/account/makeField.js